import styled from 'styled-components'

export const Subtitle = styled.h2`
  font-size: 30px;
  font-weight: 500;
  margin-bottom: 40px;

  ${({ lessMargin }) =>
    lessMargin &&
    `
    margin-bottom: 20px;
  `}

  color: ${({ theme }) => theme.brand.forest};
`

export const SubSubTitle = styled.h3`
  display: block;
  text-decoration: none !important;

  font-size: 20px;
  font-weight: 500;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.brand.forest};
`
